import React from 'react';
import { VerificationForm } from '@sheerid/jslib';
import '@sheerid/jslib/sheerid.css';
import './App.css';

import { programId } from './programOptions';

const App = () => (
    <div className="sid-verification-form">
        <div className="sid-logo sid-l-horz-center">
            <img
                className="sid-logo__img"
                alt="Logo"
                src="https://assets-resources.sheerid.com/alteryx/img/sheer-id-text-form-lable-capture.PNG"
            />
        </div>
        <VerificationForm programId={programId} />
    </div>
);

export default App;
